export type SortItemValue = {
  field: string;
  sortAsc: boolean;
};

export type SortItem = {
  Value: SortItemValue;
  Title: string;
};

export const AvailableSortItems: SortItem[] = [
  {
    Title: "Alphabetical",
    Value: {
      field: "alpha",
      sortAsc: false,
    },
  },
  {
      Title: "Oldest Date First",
    Value: {
      field: "date",
      sortAsc: true,
    },
  },
  {
      Title: "Most Recent Date First",
    Value: {
      field: "date",
      sortAsc: false,
    },
  },
  {
    Title: "Relevance",
    Value: {
      field: "relevance",
      sortAsc: false,
    },
  }
];

export const DisciplineAvailableSortItems: SortItem[] = [
  {
    Title: "Number Ascending",
    Value: {
      field: "number",
      sortAsc: true,
    }
  },
  {
    Title: "Number Descending",
    Value: {
      field: "number",
      sortAsc: false,
    },
  },
  {
    Title: "Name A->Z",
    Value: {
      field: "name",
      sortAsc: true,
    }
  },
  {
    Title: "Name Z->A",
    Value: {
      field: "name",
      sortAsc: false,
    },
  },
  {
    Title: "Relevance",
    Value: {
      field: "relevance",
      sortAsc: false,
    }
  }
];